var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#6EB0E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.616 19.5414C40.5985 19.9915 39.5195 20.2872 38.4147 20.4187C39.5787 19.7215 40.4497 18.625 40.8653 17.3334C39.772 17.984 38.5733 18.44 37.3253 18.6867C36.4861 17.7888 35.3738 17.1933 34.1613 16.9928C32.9487 16.7923 31.7039 16.998 30.6204 17.578C29.5368 18.1579 28.6752 19.0796 28.1695 20.1997C27.6638 21.3199 27.5423 22.5757 27.824 23.772C25.6066 23.6611 23.4373 23.085 21.457 22.0812C19.4767 21.0774 17.7296 19.6683 16.3293 17.9454C15.8337 18.7966 15.5733 19.7643 15.5747 20.7494C15.5747 22.6827 16.56 24.3907 18.0547 25.3907C17.1693 25.3628 16.3035 25.1237 15.5293 24.6934V24.7614C15.5293 26.0492 15.9747 27.2974 16.79 28.2943C17.6054 29.2911 18.7404 29.9753 20.0027 30.2307C19.1809 30.4536 18.3191 30.4865 17.4827 30.3267C17.8386 31.4352 18.5323 32.4047 19.4667 33.0992C20.401 33.7938 21.5293 34.1787 22.6933 34.2C21.5365 35.1086 20.2118 35.7803 18.7952 36.1765C17.3786 36.5728 15.8977 36.6859 14.4373 36.5094C16.9863 38.1485 19.9535 39.0188 22.984 39.016C33.2427 39.016 38.8507 30.5187 38.8507 23.1494C38.8507 22.9094 38.8453 22.6667 38.8347 22.428C39.9259 21.6392 40.8677 20.6608 41.616 19.5414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.63c9c5a7add2f12771170be5bf64cbe4.svg";
export { ForwardRef as ReactComponent };